import actions from './actions';
import initialState from '../initialState';

export const searchReducer = (state = initialState.searchState, action) => {
    switch (action.type) {
        case actions.SET_SEARCH_TEXT:
            return { ...state, searchText: action.state.searchText };
        default:
            return state;
    }
};

export default searchReducer;
